import { useEffect, useState } from 'react';
import './style.css';

const ToggleButton = ({ label1, label2, leftValue, rightValue, value = leftValue, onChange }) => {
  const [active, setActive] = useState(value);

  useEffect(() => {
    setActive(value);
  }, [value]);

  const handleClick = (val) => {
    setActive(val);
    if (onChange) {
      onChange(val);
    }
  };

  return (
    <div className="toggle-btn-container">
      <button
        className={`toggle-btn toggle-btn-left ${active === leftValue ? 'toggle-btn-active' : 'toggle-btn-inactive'}`}
        onClick={() => handleClick(leftValue)}
      >
        {label1}
      </button>
      <button
        className={`toggle-btn toggle-btn-right ${active === rightValue ? 'toggle-btn-active' : 'toggle-btn-inactive'}`}
        onClick={() => handleClick(rightValue)}
      >
        {label2}
      </button>
    </div>
  );
};

export default ToggleButton;

